"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token = void 0;
var Token = /** @class */ (function () {
    function Token(type, content, attributes, text) {
        this.type = type;
        this.content = content;
        this.attributes = attributes;
        this.text = text;
    }
    Token.prototype.toString = function () {
        return this.content + " (" + this.type + ")";
    };
    Token.prototype.equals = function (token) {
        return this.type === token.type && this.content === token.content;
    };
    Token.prototype.convertToTextToken = function () {
        var _a;
        if (this.type === Token.Type.startTag) {
            this.content = (_a = this.text) !== null && _a !== void 0 ? _a : '';
            this.type = Token.Type.text;
        }
        else if (this.type === Token.Type.endTag) {
            this.content = "[/" + this.content + "]";
            this.type = Token.Type.text;
        }
    };
    return Token;
}());
exports.Token = Token;
(function (Token) {
    var Type;
    (function (Type) {
        Type[Type["text"] = 0] = "text";
        Type[Type["startTag"] = 1] = "startTag";
        Type[Type["endTag"] = 2] = "endTag";
    })(Type = Token.Type || (Token.Type = {}));
})(Token = exports.Token || (exports.Token = {}));
exports.Token = Token;
